import algoliasearch from "algoliasearch/lite";
import tableSearch from "@/views/dashboard/shared/tableSearch/tableSearch.vue";
import OrderApi from "@/services/api/orderApi";
import _debounce from "lodash/debounce";
import { mapGetters } from "vuex";

const OrderApiService = new OrderApi();

export default {
  components: {
    tableSearch,
  },

  methods: {
    exportOrders,
    onSearchQueryChange,
    search: _debounce(search, 500),
    getSuborders,
    updateTableData,
    toggleRow,
    toggleSort,
    fetchOrder,
    statusChangeCallback,
    initOrdersIndex,
  },

  data() {
    return {
      searchIndexOrders: null,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      query: "",
      selectedStatus: "",
      orders: {},
      suborders: null,
      statuses: [
        { name: "ALL" },
        { name: "PAID" },
        { name: "FULFILLMENT_IN_PROGRESS" },
        { name: "PENDING" },
        { name: "APPROVED" },
        { name: "DECLINED" },
        { name: "EXPIRED" },
        { name: "SHIPPED" },
      ],
      pagination: {
        page: 1,
        limit: 12,
        totalCount: 0,
      },
      tabLinks: [{ name: "Orders", path: "orders", routeName: "orders" }],
    };
  },

  beforeMount() {
    this.initOrdersIndex();
    this.tabLinks.push({ name: "Custom Assortments", path: "custom-assortments", routeName: "customAssortments" });
    this.updateTableData(this.$route.query.page);
  },

  computed: {
    sort,
    sortName,
    sortValue,
    ...mapGetters({
      user: "userState",
    }),
  },
};

function exportOrders() {
  const _self = this;

  _self.$loader.$emit("trigger", true);

  OrderApiService.retailerExportToCSV()
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data])),
        link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "bulletin_orders.csv");
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    })
    .finally(() => {
      _self.$loader.$emit("trigger", false);
    });
}

function onSearchQueryChange(val) {
  this.pagination.page = 1;
  this.query = val;

  this.suborders = null;
  this.search();
}

function search() {
  this.updateTableData();
}

function getSuborders(page) {
  if (page) this.pagination.page = Number(page);

  this.searchIndexSuborders.clearCache();
  this.searchIndexSuborders
    .search({
      query: this.query,
      page: this.pagination.page - 1,
      hitsPerPage: this.pagination.limit,
      facets: "*",
      facetFilters: [
        `retailer_id:${this.user.retailer_id}`,
        this.selectedStatus === "" || this.selectedStatus.name === "ALL" ? [] : `status:${this.selectedStatus.name}`,
      ],
    })
    .then((response, err) => {
      if (err) {
        this.$swal("Attention", _self.$utils.formatErrorMessage("orders"));

        return;
      }

      let suborders = response.hits;

      this.pagination.totalCount = response.nbHits;
      this.suborders = suborders;
    });
}

function updateTableData(page) {
  if (page) {
    this.$router.replace({
      query: { page: page },
    });
  }

  this.getSuborders(page);
}

function toggleRow(id) {
  this.suborders = this.suborders.map((suborder) => {
    if (suborder.id === id) {
      if (!suborder.expanded && this.orders[suborder.order_number] === undefined) {
        this.fetchOrder(suborder.order_id);
      }

      return {
        ...suborder,
        expanded: !suborder.expanded,
      };
    }

    return suborder;
  });
}

function toggleSort(sort) {
  const descending = !this.sort || (this.sortName === sort && this.sortValue === "desc");

  this.$router.replace({
    query: {
      ...this.$route.query,
      sort: `${sort}:${descending ? "asc" : "desc"}`,
    },
  });

  this.initOrdersIndex();
  this.updateTableData();
}

async function fetchOrder(order_id) {
  if (!this.orders[order_id]) {
    this.orders = {
      ...this.orders,
      [order_id]: null,
    };
  }

  try {
    const { data } = await OrderApiService.getOrderMoreInfo(order_id);

    this.orders = {
      ...this.orders,
      [order_id]: data,
    };
  } catch (error) {
    if (error.response) {
      this.$swal("Attention", error.response.data.error_message);
    } else {
      this.$logger.notify(new Error(error));
    }
  }
}

function statusChangeCallback(val) {
  if (val === "ALL") {
    this.selectedStatus = "";
  } else {
    this.selectedStatus = val;
  }

  this.pagination.page = 1;

  this.updateTableData();
}

function initOrdersIndex() {
  this.searchIndexSuborders = this.algoliaClient.initIndex(
    this.$env.getOrigin() + `_suborders${this.sort ? `_${this.sort.replace(":", "_")}` : ""}`
  );
}

function sort() {
  // ?sort=date:asc
  if (this.$route.query["sort"] && /(\w*:\w*)/.test(this.$route.query["sort"])) return this.$route.query["sort"];

  return "";
}

function sortName() {
  return this.sort ? this.sort.split(":")[0] : "";
}

function sortValue() {
  return this.sort ? this.sort.split(":")[1] : "";
}
